import moment from 'moment';
import { formatDateWithoutSeconds, findNumberOfFiles } from 'utils';
import { LinkQueryResult } from '../../traceInspector.types';
import { CloudUpload } from 'lucide-react';

type Props = {
  link: LinkQueryResult;
};

export const WhoDidWhatWhen = ({ link }: Props) => {
  const renderNbDocuments = () => {
    if (!link?.data) return null;

    const fileLength = findNumberOfFiles(link.data);

    if (fileLength === 0) return null;

    return (
      <span
        data-cy="number-of-files"
        className="bg-accent text-accent-foreground border-border flex items-center gap-2 rounded-full border px-3 py-1 font-bold select-none"
      >
        <CloudUpload size={14} />
        {fileLength === 1 ? '1 file' : `${fileLength} files`}
      </span>
    );
  };

  const createdAt = moment.utc(link.createdAt).local();

  const whatGroup = link?.group?.name;

  return (
    <div className="text-muted-foreground flex items-center gap-2.5 text-xs">
      <p>
        Submitted{' '}
        {whatGroup && (
          <>
            by <span className="font-semibold">{whatGroup}</span>,
          </>
        )}{' '}
        on {formatDateWithoutSeconds(createdAt)}
      </p>
      {renderNbDocuments()}
    </div>
  );
};

WhoDidWhatWhen.displayName = 'WhoDidWhatWhen';
